import { PillChip } from './PillChip';
import type { PillColor } from './pill-tone';

export type { PillColor };

interface PillSelectProps {
  color?: PillColor;
  disabled?: boolean;
  label: string;
  loading?: boolean;
  onChange: (value: string) => void;
  options: { label: string; value: string }[];
  value: string | string[];
}

export const PillSelect = ({
  color,
  disabled,
  label,
  loading,
  onChange,
  options,
  value,
}: PillSelectProps) => {
  const selected = new Set(Array.isArray(value) ? value : [value]);

  return (
    <div className="grid gap-1">
      <span className="text-xs font-medium text-ink-subtle">{label}</span>
      <div className="flex flex-wrap gap-1.5">
        {options.map((opt) => {
          const active = selected.has(opt.value);

          return (
            <PillChip
              active={active}
              color={color}
              disabled={disabled ?? loading}
              key={opt.value}
              onClick={() => {
                onChange(opt.value);
              }}
            >
              {active ? <span aria-hidden className="h-1.5 w-1.5 rounded-full bg-current" /> : null}
              {opt.label}
            </PillChip>
          );
        })}
      </div>
    </div>
  );
};
